import { render, staticRenderFns } from "./StartWizard.vue?vue&type=template&id=0ea1a19b&scoped=true&"
import script from "./StartWizard.vue?vue&type=script&lang=ts&"
export * from "./StartWizard.vue?vue&type=script&lang=ts&"
import style0 from "./StartWizard.vue?vue&type=style&index=0&id=0ea1a19b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea1a19b",
  null
  
)

export default component.exports